import salesItemCalculator from "./salesItemCalculator";

const salesTotalsCalculator = (salesItems, recipientNames) => {

  const recipientShares = [];
  recipientNames.forEach(recipientName => {
    recipientShares.push({
      name: recipientName,
      share: 0
    })
  });

  // console.log("Recip shares", recipientShares);

  const totals = {
    numberSold: 0,
    numberGifted: 0,
    numberPaypal: 0,
    totalRevenue: 0,
    paypalCommission: 0,
    netRevenue: 0,
    recipientShares: recipientShares
  };

  // console.log("Totals object", totals);

  salesItems.forEach(salesItem => {
    const item = salesItemCalculator(salesItem);
    totals.numberSold += item.numberSold;
    totals.numberGifted += item.numberGifted;
    totals.numberPaypal += item.numberPaypal;
    totals.totalRevenue += item.totalRevenue;
    totals.paypalCommission += item.paypalCommission;
    totals.netRevenue += item.netRevenue;
    
    recipientNames.forEach(recipientName => {
      const recipientItemObj = item.recipientShares
        .find(recipientShare => recipientShare.name === recipientName)
        || { name: "", share: 0};
      
      totals.recipientShares
        .find(recipientShare => recipientShare.name === recipientName)
        .share += recipientItemObj.share;
    });
    
  })

  return totals;

};

export default salesTotalsCalculator;